<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    transition="dialog-bottom-transition"
    :overlay="false"
  >
    <v-card>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="dialog = false" dark>
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Selecciona un vehículo</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-layout row>
            <v-flex xs12>
              <v-autocomplete
                class="mt-5"
                :items="vehicles"
                item-text="plate"
                return-object
                v-model="vehicleSelect"
                prepend-icon="directions_car"
                label="Vehículos"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'vehicle-dialog',
  props: {
    vehicles: Array,
    selectedVehicle: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      dialog: false,
      vehicleSelect: null
    }
  },
  watch: {
    vehicleSelect: function (vehicleSelect) {
      this.$emit('update:selectedVehicle', vehicleSelect)
    }
  },
  methods: {
    open: function () {
      this.dialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tracking/VehicleDialog.vue